import { createSelector } from '@reduxjs/toolkit';
import { selectSecurity } from '../../store/selectors';

export const selectCommon = createSelector(selectSecurity, (securityState) => securityState);
export const selectSecurityDetails = createSelector(selectCommon, (common) => common.common.securityDetails);
